import { eventStateSelector, JoiEvent, makeEmptyLabelMaps, PublishInfo } from 'src/app/store/events.era';
// import { Performer } from 'src/app/store/performers.era';
// import { publicPublishTimelineReselector } from './programs.reselector';
// import { AppState } from './../store';
import { createSelector } from '@ngrx/store';
// import { PublicEventData, PublicTimelineItem, PublicEventInfo } from '../../models/public.model';
import { addPropertyToObjectList, copyObjectWithProps, date2str, flatten, getNestedSet, getProgramDayFilters, jsonCopyObject, makeMapFromListOfObjectsAndKey, makeMapFromListOfObjectsAndKeyToProperty, removePropertyFromObjectList, sortByProp, sortByPropOfNumber, str2Date } from '../../../../globals/helpers/helpers';
import { userStateSelector } from '../user.era';
import { EventsState } from '../events.era';
import { eventDateStringJoiner } from '../../../../globals/helpers/helpers';
import { EventStatus, Label, Venue } from 'globals/store/events.data';
import { PublicEventData, PublicEventInfo, PublicTimelineItem } from 'globals/store/public.model';
import { FilterGroup, FiltersState, filterStateSelector } from '../filters.era';
import { CoreEntityType, getLinkedVenue } from 'globals/store/share.data';
import { JoiAccount } from 'globals/store/accounts.data';
import { INTERNAL_PUBLISH_VERSION } from 'globals/helpers/constants';
import { JoiAppInfo } from 'globals/store/app.data';
import { getProgramIdsByExhibitorIds } from 'globals/helpers/program.helper';
import { getSponsorGroupings } from 'globals/store/sponsors.data';
import { getBrandingData } from 'globals/store/publish.data';
import { getStandIdsByExhibitorIds } from 'src/app/modules/program/program.helpers';
import { AccessType } from 'globals/store/permissions.data';
import { getDateRangeForStartEndDates } from '../share.event-lists.functions';
import { Dictionary } from '@ngrx/entity';
import publicHelpers from 'globals/helpers/public-helpers';
import { accountStateSelector } from '../accounts.era';
import { Program, programsStateSelector } from '../programs.era';
import { shareStateSelector } from '../share.era';
import { appsStateSelector } from '../app.era';
import { permissionsStateSelector } from '../permissions.era';
import { Performer } from '../performers.era';
import { publicPerformerKeys } from 'globals/store/performers.data';
import { publicPublishTimelineReselector } from './programs.reselector';
// import { FilterGroup, FiltersState } from 'src/app/store/filters.era';
// import { publicPerformerKeys } from '../performers.data';import { getSponsorGroupings } from '../sponsors.data';
//  '../sponsors.data';import { Program } from 'src/app/store/programs.data';
// import { EventStatus, Label, Venue } from '../events.data';
// import { getLinkedVenue } from '../share.data';
// import { getDateRangeForStartEndDates } from '../share.event-lists.functions';
// import { Dictionary } from '@ngrx/entity';
// import publicHelpers from 'src/app/helpers/public-helpers';
// import { AccessType } from '../permissions.data';
// import { getProgramIdsByExhibitorIds, getStandIdsByExhibitorIds } from './../../modules/program/program.helpers';
// import { CoreEntityType } from 'src/app/store/share.data';
// import { INTERNAL_PUBLISH_VERSION } from '../../helpers/constants';
// import { getBrandingData } from '../publish.data';
// import { JoiAccount } from '../accounts.data';
// import { JoiAppInfo } from '../app.data';


const eventEntities = createSelector(eventStateSelector, (state) => state.entities);
const event = createSelector(eventStateSelector, (state) => state.event)

const user = createSelector(userStateSelector, (state) => state.user)
const account = createSelector(accountStateSelector, (state) => state.account)
const programs = createSelector(programsStateSelector, (state) => state.entities)
const filters = createSelector(filterStateSelector, (state) => state)
const publishInfos = createSelector(shareStateSelector, (state) => state.publish)
const appInfos = createSelector(appsStateSelector, (state) => state.entities)
const permissionsByEvent = createSelector(permissionsStateSelector, (state) => state.permissionsByEvent)
const suspendedAccounts = createSelector(accountStateSelector, (state) => state.suspended)
const makePublicPerformer = (p:Performer) => copyObjectWithProps(publicPerformerKeys, p)

const convertPublicPerformers = (performers:{[s:string]:Performer}, prefilteredPerformerIds) => {
  const publicPerformers = {}
  if (performers) 
    Object.keys(performers)
      .filter(pId => prefilteredPerformerIds && prefilteredPerformerIds.has(pId) && !performers[pId].hideInPublish)
      .forEach(pId => publicPerformers[pId] = makePublicPerformer(performers[pId]))
  return publicPerformers
}
export interface EventMessagesReselectorResult {
  messages, cutoff, hasNewMessages, newMessageIds
}
export const eventMessagesReselector = createSelector(
  event,
  user,
  (event, user): EventMessagesReselectorResult | null => {
    if (!user || !event) return null
    const rawMessages = jsonCopyObject(event.messages || {})
    const messages = Object.values(rawMessages).sort(sortByPropOfNumber('dateModified', 1))
    const cutoff = event.messageCutoffs[user.uid] || 0
    messages.filter(m => typeof m.createdAt === 'string').forEach(m => m.createdAt = { seconds: m.dateModified / 1000 } as any)

    const hasNewMessages = !!messages.find(m => m['dateModified'] > cutoff && m.createdBy !== user.email)
    const newMessageIds = messages.filter(m => m['dateModified'] > cutoff && m.createdBy !== user.email).map(m => m.id)
    // console.log(messages)
    return { messages, cutoff, hasNewMessages, newMessageIds }
  }
)

export const getEventStatus = (event: JoiEvent, ignoreCompleted: boolean = false): EventStatus => {
  if (!event) return null
  else if (event.eventStatus === 'Cancelled') return 'Cancelled' // must be before closed to override closed
  else if (event.closed && !ignoreCompleted) return event.closeReason ? 'Cancelled' : 'Completed'
  else if (!event.eventStatus) return 'Pending'
  else return event.eventStatus
}

export const eventStatusReselector = createSelector(
  event,
  getEventStatus
)

export const allEventsStatusReselector = createSelector(
  eventEntities,
  (events, eventId: string) => {
    const event = events[eventId]
    if (!event) return null
    return getEventStatus(event, true)
  }
)

export const eventReadOnlyReselector = createSelector(
  event,
  (event) => !event || event.is_readonly || event.closed
)

export const eventListReselector = createSelector(eventEntities, (events): JoiEvent[] =>Object.values(events).sort(sortByProp('title')))
export const workforceEventListReselector = createSelector(
  eventListReselector,
  (events) => events.filter(e => e.can_access)
)

export interface EventMenuSelection { id: string, title: string, dateRange: string }
export const eventSelectionsReselector = createSelector(
  workforceEventListReselector,
  permissionsByEvent,
  suspendedAccounts,
  (eventList: JoiEvent[], permissionsByEvent, suspendedAccounts): EventMenuSelection[] => {
    return eventList.filter(event => 
        !event.closed && 
        permissionsByEvent[event.eventId] && 
        ['program' as AccessType, 'logistics' as AccessType].some(p => permissionsByEvent[event.eventId].includes(p)) &&
        !event.is_readonly &&
        !suspendedAccounts[event.accountId] && 
        !event.is_invited        
      ).map(event => {
      const dates = !event.dates || !event.dates.length ? null : event.dates.map(d => str2Date(d).getTime()).sort()
      let dateRange: { start: string, end: string } = null
      if (dates) dateRange = { start: date2str(new Date(dates[0])), end: date2str(new Date(dates[dates.length - 1])) }
      return {
        id: event.eventId,
        title: event.title || "Unnamed event",
        dateRange: getDateRangeForStartEndDates(dateRange)
      }
    })
  }
)

export const eventTaskLabelMapsReselector = createSelector(
  eventListReselector,
  (eventList: JoiEvent[]): Dictionary<Dictionary<Label>> => {
    const labelMapsByEventId = {}
    eventList.map(e => labelMapsByEventId[e.eventId] = publicHelpers.makeLabelMap(e.task_labels))
    return labelMapsByEventId
  }
)


export const eventTitleSelector = createSelector(eventStateSelector, (eventState) => eventState.event ? eventState.event.title : '')
export const isEventClosedReselector = createSelector( eventStateSelector, (eventState) => eventState.event && eventState.event.closed)

export const eventDateStringReselector = createSelector(
  event,
  (event: JoiEvent) => eventDateStringJoiner(event?.dates_string)
)

export const submitterTemplatesReselector = createSelector(
  event,
  (event: JoiEvent, type: CoreEntityType) => event?.submitters[type] || []
)
export interface PublishReselectorData { eventData: PublicEventData, linkedVenue: Venue }

export const publicEventDataReselector = createSelector(
  account,
  event,
  createSelector(eventStateSelector, (eventState) => eventState.labelMaps),
  programs,
  publishInfos,
  appInfos,
  publicPublishTimelineReselector,
  filters,
  (account: Partial<JoiAccount>, event: JoiEvent, labelMaps, programs: { [id:string]: Program}, publishInfos: { [id:string]: PublishInfo }, appInfos: { [id: string]: JoiAppInfo }, { timeline, prefilteredPerformerIds }: { timeline:PublicTimelineItem[][], prefilteredPerformerIds: Set<string> }, allFilters: FiltersState, { publishCode, filter, appId }: { publishCode?: string, filter, appId?: string }): PublishReselectorData => {
    
    const filters = appId ? allFilters.app : allFilters.publish

    if (!labelMaps) labelMaps = makeEmptyLabelMaps()
    const emptyPublicEventData: PublicEventData = {
      eventInfo: {} as PublicEventInfo,
      timeline: [],
      timeZoneIdsByProgram: {},
      internalVersion: INTERNAL_PUBLISH_VERSION,
      homePageData: null,
      brandingData: null,
    }

    if (!event || !timeline) return { eventData: emptyPublicEventData, linkedVenue: null }

    let info: PublishInfo | JoiAppInfo
    
    if (appId) info = appInfos[appId]
    else info = publishInfos[publishCode]
    
    const performers = convertPublicPerformers( event.performers, prefilteredPerformerIds)
    const profilePerformers = jsonCopyObject(performers)
    if (info.homePageData.performerIds) info.homePageData.performerIds.filter(id => !performers[id]).forEach(id => performers[id] = makePublicPerformer(event.performers[id]))

    const sponsors = event ? jsonCopyObject(event.sponsors) : {}
    Object.keys(sponsors).forEach(sponsorId=>{ if(sponsors[sponsorId].hideInPublish) delete sponsors[sponsorId]; })

    const exhibitors = event ? jsonCopyObject(event.exhibitors) : {}
    Object.keys(exhibitors).forEach(id=>{ if(exhibitors[id].hideInPublish) delete exhibitors[id]; })

    const selectedProgramLabelsMap = makeMapFromListOfObjectsAndKeyToProperty((timeline as any).flat().map(d => d.program) as PublicTimelineItem[], 'id', 'labels')
    const programIds: string[] = Array.from(new Set(flatten(timeline).map(item => item.program.id).filter(id => programs[id])))
    const timeZoneIdsByProgram = {}
    programIds.forEach(id => timeZoneIdsByProgram[id] = programs[id].timeZoneDetails.timeZoneId)

    const programIdsByExhibitor = getProgramIdsByExhibitorIds(event.exhibitorStands)
    const exhibitorList = !event || !event.exhibitors ? [] : Object.values(event.exhibitors).filter(e => {
      const exhibitorProgramIds = programIdsByExhibitor[e.id] || []
      return programIds.some(pId => exhibitorProgramIds.includes(pId) ) && 
        !e.hideInPublish &&
        (!filters.programs || filters.programs.some(pId => exhibitorProgramIds.includes(pId))) && 
        (!filters.programLabels || (exhibitorProgramIds.some(pId => !!selectedProgramLabelsMap[pId]) && filters.programLabels.some(l => exhibitorProgramIds.some(pId => selectedProgramLabelsMap[pId].includes(l)))))
    }
  

    )

    const profileExhibitors = jsonCopyObject(makeMapFromListOfObjectsAndKey(exhibitorList, 'id'))
    exhibitorList.sort(sortByProp('name'))
    const exhibitorIds = exhibitorList.sort(sortByProp('name')).map(e => e.id)
    const { sponsorGroupings, sponsorTypesMap: sponsorTypes } = getSponsorGroupings(sponsors, event.sponsorTypes || [])
    // console.log({ profileExhibitors, exhibitorList, timeline, programIds, exhibitorIds })

    
    const brandingData = getBrandingData({ acc: account, publishInfos, brandingSelectData: { type: 'publish', publishId: publishCode } })
    // console.log({ brandingData })

    const unfilteredEventData: PublicEventData = {
      brandingData,
      homePageData: info.homePageData || null,
      internalVersion: INTERNAL_PUBLISH_VERSION,
      eventInfo:{
        performerRoles: makeMapFromListOfObjectsAndKey(event.performerRoles || [], 'id'),
        eventId:event.eventId,
        event_title:event.title,
        title: info.title,
        description: info.description,
        event_dates_string: info.excludedFieldIds?.includes('eventDate') ? event.dates_string : null,
        profileExhibitors,
        exhibitorIds,
        performers,
        exhibitors,
        profilePerformers,
        sponsors,
        sponsorGroupings,
        sponsorTypes,
        profileSponsors: jsonCopyObject(sponsors),
        performer_labels:labelMaps.performer_labels,
        sponsor_labels:labelMaps.sponsor_labels,
        program_labels:labelMaps.program_labels,
        session_labels:labelMaps.session_labels,
        exhibitor_labels: labelMaps.exhibitor_labels,
        viewMyTimezoneToggle: info.excludedFieldIds?.includes('viewMyTimezoneToggle') ? true : false,
        venues: event.venues || {},
      },
      timeline,
      timeZoneIdsByProgram
    }
    const eventData = !filter ? unfilteredEventData : filterEventDataByFields(info.excludedFieldIds, unfilteredEventData, filters)
    if (eventData.eventInfo.profileExhibitors && !info.excludedFieldIds?.includes('exhibitorStandNumber')) {
      const standIdsByExhibitorIds = getStandIdsByExhibitorIds(event.exhibitorStands)
      const exhibitors = Object.values(eventData.eventInfo.profileExhibitors)
      exhibitors.forEach(e => e.locationText = (standIdsByExhibitorIds[e.id] || []).map(s => {
        const { programId, name } = event.exhibitorStands[s]
        return [ name, programs[programId]?.location ].filter(p => p).join(", ")
      }).filter(t => t).join(" | ")) 
    }
    console.log({ eventData, unfilteredEventData })
    return { eventData, linkedVenue: getLinkedVenue(event, info.excludedFieldIds, info.venueId, eventData.timeline ) }
  }
)

// THIS is the main program publish filtering function
export const filterEventTimeline = (eventData: PublicEventData, filters: FilterGroup): PublicEventData => {
  if (!filters || !filters.count) return eventData
  if (filters.performers && eventData.eventInfo.performers) {
    Object.keys(eventData.eventInfo.performers).filter(id => !filters.performers.includes(id)).forEach(id => delete eventData.eventInfo.performers[id])
  }
  if (filters.sponsors && eventData.eventInfo.sponsors) {
    Object.keys(eventData.eventInfo.sponsors).filter(id => !filters.sponsors.includes(id)).forEach(id => delete eventData.eventInfo.sponsors[id])
  }

  // console.log("before: ", jsonCopyObject(eventData), { filters })
  const { programDayFilters, anyProgramAtLeastPartiallySelected } = getProgramDayFilters(filters)


  eventData.timeline = eventData.timeline.map(daySession => {
    daySession = daySession.filter(session => {
      // console.log(session.title, { session })
      const program = session.program
      const programSelected = filters.programs && filters.programs.includes(program.id)
      const programLabelSelected = !!filters.programLabels && program.labels && program.labels.some(l => filters.programLabels.includes(l))
      const programSelectedWithoutDays = !programDayFilters[program.id] && (programLabelSelected || programSelected)
      const daySelected = !!programDayFilters[program.id] && programDayFilters[program.id].has(session.on_day)

      return ![
        !filters.sessionLabels || (session.labels && session.labels.some(l => filters.sessionLabels.includes(l))),
        !anyProgramAtLeastPartiallySelected || programSelectedWithoutDays || daySelected,
        !filters.performers || (session.performerIds && session.performerIds.some(pId => filters.performers.includes(pId))),
        !filters.sponsors || (session.sponsorIds && session.sponsorIds.some(sId => filters.sponsors.includes(sId))),
      ].some(passesFilter => !passesFilter)
    })
    daySession.forEach(session => {
      session.performerIds = session.performerIds ? session.performerIds.filter(id => eventData.eventInfo.performers && eventData.eventInfo.performers[id]) : null
      session.sponsorIds = session.sponsorIds ? session.sponsorIds.filter(id => eventData.eventInfo.sponsors && eventData.eventInfo.sponsors[id]) : null
    })
    return daySession
  })
  eventData.timeline = eventData.timeline.filter(daySession => daySession.length)
  // console.log("after: ", jsonCopyObject(eventData))

  return eventData

}


export const filterEventDataByDisplayOptions = (excludedFieldIds: string[], eventData: PublicEventData): PublicEventData => {
  if (!excludedFieldIds || !excludedFieldIds.length) return eventData
  const { eventInfo, timeline } = eventData
  eventInfo.venues = eventInfo.venues || {}
  excludedFieldIds.includes('eventDate') &&
    timeline.forEach((daySessions, index) =>
      daySessions.forEach(session => {
        session.displayDate = `Day ${index+1}`
        delete session.datetime
        delete session.session_date
        delete session.date
        delete session.program.date
      })
    )

  const sessions = timeline.reduce((allSessions, sessions) => [...allSessions, ...sessions], [])

  const postFilteredPerformerIds = getNestedSet(sessions, 'performerIds') // <== easiest to stick in here.  Might want to move this up into the place before performers and profile performers are set on eventInfo, but this is quick and dirtier
  Object.keys(eventInfo.profilePerformers).forEach(pId => {
    if (!postFilteredPerformerIds.has(pId)) {
      delete eventInfo.profilePerformers[pId]
      delete eventInfo.performers[pId]
    }
  })

  const programs = sessions.map(s => s.program) // <== there are a bunch of repeat programs in the timeline because that is how it was created, but I'm not rewriting the data structure for this right now
  // console.log({ sessions, programs, timeline, eventInfo })


  const performers = Object.values(eventInfo.performers)
  const profilePerformers = Object.values(eventInfo.profilePerformers)
  const sponsors = Object.values(eventInfo.sponsors)
  const profileSponsors = Object.values(eventInfo.profileSponsors)
  const profileExhibitors = Object.values(eventInfo.profileExhibitors)


  eventInfo.venues = jsonCopyObject(eventInfo.venues)
  // console.log({ excludedFieldIds })
  excludedFieldIds.forEach(fieldId => {

    // going for clarity over performance & succintness here
    switch (fieldId) {
      case 'eventName':
        delete eventInfo.event_title
        break;
      case 'publishedName':
        // delete eventInfo.title <== CANNOT REMOVE THIS.  IS NEEDED IN EVENT LIST FOR LINKS
        break;
      case 'publishedDescription':
        delete eventInfo.description
        break;
      case 'viewMyTimezoneToggle':
        // console.log('viewMyTimezoneToggle');
        // console.log({ eventInfo});
        eventInfo.viewMyTimezoneToggle = false;
        break;
      case 'eventDate':
        // handled above as is a special case
        break;
      case 'programName':
        removePropertyFromObjectList(programs, 'title')
        break;
      case 'location':
        removePropertyFromObjectList(programs, 'location')
        break;
      case 'venue':   
        Object.values(eventInfo.venues).forEach(venue => venue.venue = null) // cleanest way of doing this but may want to consolidate venue stuff later
        break;
      case 'address':
        Object.values(eventInfo.venues).forEach(venue => venue.address = null) 
        break;
      case 'sessionTitle':
        removePropertyFromObjectList(sessions, 'title')
        break;
      case 'sessionDescription':
        removePropertyFromObjectList(sessions, 'description')
        break;
      case 'publicLinks':
        removePropertyFromObjectList(sessions, 'publicLinks')
        break;
      case 'sessionLabels':
        removePropertyFromObjectList(sessions, 'labels')
        delete eventInfo.session_labels
        break;
      case 'performers':
        delete eventInfo.performers
        break;
      case 'performerName':
        eventInfo.performers && removePropertyFromObjectList(performers, 'name')
        break;
      case 'line1':
        eventInfo.performers && removePropertyFromObjectList(performers, 'line1')
        break;
      case 'line2':
        eventInfo.performers && removePropertyFromObjectList(performers, 'line2')
        break;
      case 'performerLabels':
        eventInfo.performers && addPropertyToObjectList(performers, 'hideLabels', true)
        break;
      case 'bio':
        eventInfo.performers && removePropertyFromObjectList(performers, 'bio')
        break;
      case 'social':
        eventInfo.performers && removePropertyFromObjectList(performers, 'social')
        break;
      case 'photoUrl':
        eventInfo.performers && removePropertyFromObjectList(performers, 'photoUrl')
        eventInfo.performers && removePropertyFromObjectList(profilePerformers, 'fullPhotoUrl')
        eventInfo.performers && addPropertyToObjectList(performers, 'photoHidden', true)
        break;
      case 'logoUrl':
        eventInfo.performers && removePropertyFromObjectList(performers, 'logoUrl')
        eventInfo.performers && removePropertyFromObjectList(profilePerformers, 'fullLogoUrl')
        break;

      case 'performerProfileLine1':
        profilePerformers && removePropertyFromObjectList(profilePerformers, 'line1')
        break;
      case 'performerProfileLine2':
        profilePerformers && removePropertyFromObjectList(profilePerformers, 'line2')
        break;
      case 'performerProfileLabels':
        profilePerformers && addPropertyToObjectList(profilePerformers, 'hideLabels', true)
        // console.log({ profilePerformers })
        break;
      case 'performerProfileBio':
        profilePerformers && removePropertyFromObjectList(profilePerformers, 'bio')
        break;
      case 'performerProfileSocial':
        profilePerformers && removePropertyFromObjectList(profilePerformers, 'social')
        break;
      case 'performerProfilePhotoUrl':
        profilePerformers && removePropertyFromObjectList(profilePerformers, 'photoUrl')
        profilePerformers && removePropertyFromObjectList(profilePerformers, 'fullPhotoUrl')
        profilePerformers && addPropertyToObjectList(profilePerformers, 'photoHidden', true)
        break;
      case 'performerProfileLogoUrl':
        profilePerformers && removePropertyFromObjectList(profilePerformers, 'logoUrl')
        profilePerformers && removePropertyFromObjectList(profilePerformers, 'fullLogoUrl')
        break;
      case 'performerRoles':
        profilePerformers && removePropertyFromObjectList(sessions, 'performerRoleIds')
        delete eventInfo.performerRoles
        break
      case 'sponsors':
        delete eventInfo.sponsors
        break;
      case 'sponsorType':
        eventInfo.sponsors && removePropertyFromObjectList(sponsors, 'sponsorTypeId')
        break;
      case 'sponsorLabels':
        eventInfo.sponsors && addPropertyToObjectList(sponsors, 'hideLabels', true)
        break;
      case 'sponsorDescription':
        eventInfo.sponsors && removePropertyFromObjectList(sponsors, 'description')
        break;
      case 'sponsorSocial':
        eventInfo.sponsors && removePropertyFromObjectList(sponsors, 'social')
        break;
      case 'callToAction':
        eventInfo.sponsors && removePropertyFromObjectList(sponsors, 'callToAction')
        eventInfo.sponsors && removePropertyFromObjectList(sponsors, 'callToActionUrl')
        break;
      case 'sponsorLogoUrl':
        eventInfo.sponsors && removePropertyFromObjectList(sponsors, 'logoUrl')
        eventInfo.sponsors && addPropertyToObjectList(sponsors, 'hideLogo', true)
        break;

      case 'sponsorProfileType':
        profileSponsors && removePropertyFromObjectList(profileSponsors, 'sponsorTypeId')
        break;
      case 'sponsorProfileLabels':
        profileSponsors && addPropertyToObjectList(profileSponsors, 'hideLabels', true)
        break;
      case 'sponsorProfileDescription':
        profileSponsors && removePropertyFromObjectList(profileSponsors, 'description')
        break;
      case 'sponsorProfileSocial':
        profileSponsors && removePropertyFromObjectList(profileSponsors, 'social')
        break;
      case 'sponsorProfilecallToAction':
        profileSponsors && removePropertyFromObjectList(profileSponsors, 'callToAction')
        profileSponsors && removePropertyFromObjectList(profileSponsors, 'callToActionUrl')
        break;
      case 'sponsorProfileLogoUrl':
        profileSponsors && removePropertyFromObjectList(profileSponsors, 'logoUrl')
        profileSponsors && removePropertyFromObjectList(profileSponsors, 'fullLogoUrl')
        profileSponsors && addPropertyToObjectList(profileSponsors, 'hideLogo', true)
        break;
      case 'exhibitorStandNumber':
        // profileExhibitors && removePropertyFromObjectList(profileExhibitors, 'locationText')
        break;
      case 'exhibitorProfileLabels':
        profileExhibitors && addPropertyToObjectList(profileExhibitors, 'hideLabels', true)
        break;
      case 'exhibitorProgramName':
        // profileExhibitors && removePropertyFromObjectList(profileExhibitors, 'programId')
        break;
      case 'exhibitorProfileDescription':
        profileExhibitors && removePropertyFromObjectList(profileExhibitors, 'description')
        break;
      case 'exhibitorProfileSocial':
        profileExhibitors && removePropertyFromObjectList(profileExhibitors, 'social')
        break;
      case 'exhibitorProfilecallToAction':
        profileExhibitors && removePropertyFromObjectList(profileExhibitors, 'callToAction')
        profileExhibitors && removePropertyFromObjectList(profileExhibitors, 'callToActionUrl')
        break;
      case 'exhibitorProfileLogoUrl':
        profileExhibitors && removePropertyFromObjectList(profileExhibitors, 'logoUrl')
        profileExhibitors && removePropertyFromObjectList(profileExhibitors, 'fullLogoUrl')
        profileExhibitors && addPropertyToObjectList(profileExhibitors, 'hideLogo', true)
        break;
      case 'militaryTime':
      case 'expandByDefault':
      case 'collapseByDefault':
      case 'showTimeZone':
      case 'CTALinks':
        break;
      default:
        // console.log(`Missing program publish filtering for ${fieldId}`)
        break;

    }
  })
  return eventData
}

export const filterEventDataByFields = (excludedFieldIds: string[], eventData: PublicEventData, filters: FilterGroup): PublicEventData => {
  if ((!filters || !filters.count) && (!excludedFieldIds || !excludedFieldIds.length)) return eventData
  eventData = jsonCopyObject(eventData)
  eventData = filterEventTimeline(eventData, filters)
  eventData = filterEventDataByDisplayOptions(excludedFieldIds, eventData)
  return eventData
}

